import { directive as vClickOutside } from "vue-clickaway";
import hoverTip from "./directives/hoverTip";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive("click-outside", vClickOutside);
    Vue.directive("hover-tip", hoverTip);
  },
};

export default GlobalDirectives;
